<template>
    <div class="city-houses-section" v-if="cityHousesArr != null" id="menu-link-city">
        <div class="container">
            <sectionTitle :options="[{ title : cityHousesArr.city_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: cityHousesArr.city_quote_img, title : cityHousesArr.city_quote_title, desc: cityHousesArr.city_quote_desc}]"></sectionBaner>
            <sectionDescColumn :options="[{ desc_left : cityHousesArr.city_desc_left, desc_right: cityHousesArr.city_desc_right}]" class="section-desc-column-city-houses"></sectionDescColumn>
            <sectionImagesMobile :options="[{ images: cityHousesArr.city_images_mobile}]" v-if="isMobileGlobal"></sectionImagesMobile>
            <sectionImagesGrid :options="[{ cards: cityHousesArr.city_cards.slice(0, 3), grid_img : cityHousesArr.city_img}]" class="section-images-city-houses"></sectionImagesGrid>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import sectionImagesGrid from '@/components/partials/section-images-grid.vue'
    import sectionImagesMobile from '@/components/partials/section-images-mobile.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'city-houses-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            cityHousesArr: 'loadCityHousesArr',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
            sectionImagesGrid,
            sectionImagesMobile,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/city-houses/city-houses-section.scss';
    @import '@/styles/components/city-houses/city-houses-section-respond.scss';
</style>